export default __webpack_public_path__ + "static/blob10-f0e324043af899c1be3c6abf088c457d.svg";